import type { OpportunityCustomizationProjectItem } from "../../crm_opportunity_workbench/types";
import type { CreateCustomizationDemandResult } from "../types";
import { buildOpportunityProjectCopyTraceContent } from "./buildOpportunityProjectCopyTraceContent";

/** 对齐工作台「复制，创建新定制」：create_new + baseDemandId 直拷已填字段（不调 LLM），并为新项目补一条左侧需求追溯。 */
export function createCustomizationFromLinkedProject(
  project: OpportunityCustomizationProjectItem,
  opportunityId?: number,
  copySource?: "opportunity_linked" | "opportunity_history",
): Promise<CreateCustomizationDemandResult> {
  const baseDemandId = project.effectiveDemandId || project.currentDemandId;
  if (!baseDemandId) {
    return Promise.reject(new Error("该定制尚无需求版本，无法复制创建新定制。"));
  }
  const traceContent = buildOpportunityProjectCopyTraceContent(project);
  return import("../repo/customizationRepo").then(
    async ({ createCustomizationDemand, createCustomizationTrace }) => {
      const result = await createCustomizationDemand(project.projectId, {
        action: "create_new",
        selectedTraceIds: [],
        baseDemandId,
        ...(opportunityId !== undefined ? { opportunityId } : {}),
        ...(copySource ? { copySource } : {}),
      });
      if (traceContent) {
        await createCustomizationTrace(result.project.id, {
          role: "sales",
          sourceType: "phone",
          content: traceContent,
          isImportant: false,
        });
      }
      return result;
    },
  );
}
